import type { PeloLink } from '@core/external-links/models';
import { toWWWLink, toBusinessLink } from '@core/external-links/models';
// Canonical definition: `Audience` enum in `@onewellness/routes`. Inlined
// here as a string-literal union so `@core/links` does not need to
// depend on `@onewellness/routes` — that one type-import created a 38-project
// back-edge in the Nx graph (PARC-211 Phase 1). Keep the member list in sync
// with the enum if it ever changes; values are the enum's string payloads.
type Audience =
  | 'corporate'
  | 'liverpoolfc'
  | 'ymca'
  | 'uhc'
  | 'lululemon'
  | 'lululemon-hardware'
  | 'hyatt';

export const benefitsTerms = toWWWLink('/benefits/terms-of-service');

export const BenefitsWelcome = (audience: Audience): PeloLink =>
  toWWWLink(`/benefits/${audience}/get-set-up`);

export const benefitAddedParam = 'benefit_added=success';

const toOptionsPageUrl = (audience: Audience) => `/benefits/${audience}/options`;
export const OptionsPage = (audience: Audience): PeloLink =>
  toWWWLink(toOptionsPageUrl(audience));
export const BenefitsAccountAdded = (audience: Audience): PeloLink =>
  toWWWLink(`${toOptionsPageUrl(audience)}?success=true`);

export const corporateBenefitsProgramTerms = toWWWLink(
  '/corporate-wellness/program-terms',
);
export const corporateBenefitsProgramTermsUk = toWWWLink(
  '/corporate-wellness/program-terms-uk',
);

export const corporateWellness = toBusinessLink('/solutions/corporate-wellness');
